import React, { useState } from 'react'
import classNames from 'classnames'
import { Link } from 'react-router-dom'
import menu from 'data/menu'

export default function Sidebar({
    visible,
    setVisible,
    pathName,
    minified
}) {

    const [ expanded, setExpanded ] = useState(false)

    const Classes = classNames({
        'bg-dark fixed top-0 md:left-0 h-screen w-full z-1000 transition-all duration-200': true,
        "md:w-180 border-r border-line": !minified,
        "md:w-60": minified && !expanded,
        "md:w-180": minified && expanded,
        "-left-full": !visible,
        "left-0": visible,
    })

    return (
        <div className={Classes}>
            {minified ?
                <div className={`px-2 w-60 h-header flex justify-center items-center`}>
                    <img src="/images/logo-min-white.png" className="w-full" title="Parkagent" alt="Parkagent"/>
                </div>
            :
                <div className={`px-2 flex justify-center py-6`}>
                    <img src="/images/logo-white.png" className="h-8 w-auto" title="Parkagent" alt="Parkagent"/>
                </div>
            }
            
            {menu?.map((item, index) => {

                const Icon = item.icon;
                let isActive = false;

                if (item.href === '/') {
                    isActive = pathName === item.href
                } else {
                    if (item.active) {
                        isActive = pathName.includes(item.active)
                    } else {
                        isActive = pathName.includes(item.href)
                    }
                }

                const ItemClasses = classNames({
                    'group flex items-center px-4 py-4 transition-all': true,
                    'hover:bg-black': !isActive,
                    'bg-white rounded-tl-lg rounded-bl-lg': isActive
                })

                return (
                    <Link
                        to={item.href}
                        key={index}
                        className={ItemClasses}
                        onClick={() => setVisible()}
                        title={item.label}
                        onMouseEnter={() => setExpanded(true)}
                        onMouseLeave={() => setExpanded(false)}
                    >
                        <Icon className={`w-6 min-w-6 h-6 ${!isActive ? 'fill-lightprimary opacity-80' : 'fill-primary opacity-100'}`} />

                        {(!minified || expanded) &&
                            <div className={`text-menu pl-2 transition-all ${isActive ? 'text-dark' : 'text-white'}`}>{item.label}</div>
                        }
                    </Link>
                )
            })}
        </div>
    )
}
